import { useState } from 'react';
import { useNode } from '@craftjs/core';
import { FormTextInputComponent } from 'src/features/generalForms/builder/types/TextInput';
import {
  TitlePanel,
  LayoutPanel,
  ValidationPanel,
  TextFieldPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { AppTextField } from 'src/features/generalForms/uikit/fields/text/textField';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';

export const FormTextInput: FormTextInputComponent = (props) => {
  const { connectors, styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;
  const validationResult = useDataKeyValidation();

  const [hasFocus, setHasFocus] = useState(false);

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles} draggable={!hasFocus}>
      <AppTextField
        readOnly={true}
        type={props.type}
        disabled={props.disabled}
        placeholder={props.placeholder}
        units={props.units}
        maxLength={props.maxLength}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        value={''}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormTextInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <TextFieldPanel sections={['Placeholder']} />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel type={'text'} sections={['MaxLength', 'Pattern']} />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormTextInput.craft = {
  displayName: 'Single line',
  rules: { canDrag: () => true },
  related: { settings: FormTextInputSettings },
};
